import {UseMutationOptions, useMutation} from '@tanstack/react-query'
import type {AxiosError} from 'axios'

import type {ErrorResponse} from '../types'

import type {Mutations} from '@refra/api/mutations'

type useRefraMutationProps<Fn extends Mutations[keyof Mutations]> = {
  mutationFn: Fn
} & UseMutationOptions<Awaited<ReturnType<Fn>>, AxiosError<ErrorResponse>, Parameters<Fn>[0]>

export const useRefraMutation = <Fn extends Mutations[keyof Mutations]>({
  mutationFn,
  ...options
}: useRefraMutationProps<Fn>) => {
  return useMutation({mutationFn, ...options})
}
